import { render } from "./AdjustTrip.vue?vue&type=template&id=bfdf2526"
import script from "./AdjustTrip.vue?vue&type=script&lang=js"
export * from "./AdjustTrip.vue?vue&type=script&lang=js"
script.render = render

export default script